import { createRoute } from '@tanstack/react-router';
import { Route as parent } from './site.tsx';
export const Route = createRoute({ getParentRoute: () => parent, path: 'forms' }).lazy(() =>
  import('./site-forms.lazy.tsx').then((module) => module.Route),
);
